// src/hooks/useSearch.js
import { useState, useEffect } from 'react'
import Fuse from 'fuse.js'

import "./search.css"; 

const PAGES = [
  { title: 'Naslovna',             url: '/',                            icon: 'home',      keywords: 'početna' },
  { title: 'O nama',               url: '/onama',                       icon: 'users',     keywords: 'tim priča' },
  { title: 'Ugradnja pojaseva',    url: '/usluge/pojasevi',             icon: 'tool',      keywords: 'pojasevi ugradnja' },
  { title: 'Custom dizajn volana', url: '/usluge/custom-dizajn-volana', icon: 'steering',  keywords: 'volan dizajn' },
  { title: 'Galerija',             url: '/galerija',                    icon: 'photo',     keywords: 'galerija radovi' },
  { title: 'Kontakt',              url: '/kontakt',                     icon: 'mail',      keywords: 'kontakt email' },
]

const fuse = new Fuse(PAGES, {
  keys: ['title', 'keywords'],
  threshold: 0.4,
})

export function useSearch() {
  const [query, setQuery]     = useState('')
  const [results, setResults] = useState([])

  useEffect(() => {
    if (query.length < 2) {
      setResults([])
      return
    }
    const timer = setTimeout(() => {
      setResults(fuse.search(query).map(r => r.item))
    }, 300)
    return () => clearTimeout(timer)
  }, [query])

  return { query, setQuery, results }
}